import { DefaultTheme } from "styled-components";

export function getHolidayGradient(theme: DefaultTheme): string {
  return `repeating-linear-gradient(135deg,${theme.colors.white},${theme.colors.white} 4px,${theme.colors.grays6} 4px,${theme.colors.grays6} 8px)`;
}
